import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/css'
Swiper.use([Navigation, Pagination])


const Sliders = () => {

    document.addEventListener('DOMContentLoaded', function () {

		 const swiper = new Swiper('.mySwiper', {
			visibilityFullFit: true,
			observer: true,
			updateOnWindowResize: true,
				breakpoints: {
				  320: {
					spaceBetween: 15,
				  },
				  768: {
					spaceBetween: 56,
				  },
				  1440: {
					spaceBetween: 64,
				  },
				},
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: '.indicator__next',
				prevEl: '.indicator__prev',
			},
		})
		
		
		 const swiperActualite = new Swiper('.mySwiper-actualite', {
			visibilityFullFit: true,
			observer: true,
			updateOnWindowResize: true,
			slideToClickedSlide: true,
				breakpoints: {
				  320: {
					spaceBetween: 15,
				  },
				  768: {
					spaceBetween: 56,
					slidesPerView: 2,
				  },
				  1024: {
					slidesPerView: 3,
					spaceBetween: 64,
				  },
				},
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: '.indicator__next',
				prevEl: '.indicator__prev',
			},
		})
		
		 const swiperFlexible = new Swiper('.mySwiper-flexible', {
			visibilityFullFit: true,
			observer: true,
			updateOnWindowResize: true,
			slideToClickedSlide: true,
			slidesPerView: "auto",
				breakpoints: {
				  320: {
					spaceBetween: 11,
				  },
				  768: {
					spaceBetween: 56,
				  },
				  1024: {
					spaceBetween: 64,
				  },
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
				},
				navigation: {
					nextEl: '.indicator__next',
					prevEl: '.indicator__prev',
				},
		})
    
    })

}
    
 export default Sliders;


